import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import useFetch from '../../common/useFetch';
import config from '../../config';
import AuthService from '../../domain/AuthService';
import DashboardService from '../../domain/DashboardService';
import HistoryService from '../../domain/HistoryService';
import lottery from '../../lottery';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
import { Pager, TableLoader, useDataframe } from '../Common/Dataframe';
import DateTime from '../Common/DateTime';
import Loader from '../Common/Loader';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
var Dashboard = function () {
    var t = useTranslation()[0];
    var _a = useFetch(DashboardService.getStatus), status = _a.data, getStatus = _a.get;
    useEffect(function () {
        getStatus();
    }, []);
    var user = useContext(UserContext).user;
    return React.createElement("div", null, status && React.createElement("div", null,
        React.createElement("div", { className: gs('small') },
            React.createElement("strong", null,
                t('user'),
                ":"),
            ' ' + user.name,
            React.createElement("span", { className: gs('text-capitalize') },
                " (",
                user.role,
                ")"),
            React.createElement("strong", { className: gs('ml-4') },
                t('system_time'),
                ":"),
            ' ',
            React.createElement(DateTime, { date: status.time.date }),
            ' (',
            config.timezone,
            ")",
            React.createElement("strong", { className: gs('ml-4') },
                t('rng_version'),
                ":"),
            ' ',
            React.createElement("code", null,
                React.createElement("a", { href: status.system_version_url, target: "_blank", rel: "noopener noreferrer" }, status.system_version))),
        React.createElement("hr", { className: gs('mt-4', 'mb-4') }),
        React.createElement(Users, null),
        React.createElement("hr", { className: gs('mt-4', 'mb-4') }),
        React.createElement(History, null),
        React.createElement("hr", { className: gs('mt-4', 'mb-4') }),
        React.createElement("h3", { className: gs('mb-4') }, t('ticket_structure')),
        React.createElement("div", { className: gs('card-group', 'mb-4') }, lottery.number_structure.map(function (numbers, index) { return React.createElement("div", { className: gs('card'), key: index },
            React.createElement("div", { className: gs('card-body') },
                React.createElement("span", { className: gs('badge', 'badge-light', 'mb-2') }, lottery.number_descriptions[index]),
                React.createElement("h5", null,
                    lottery.number_alphabet[numbers[0]],
                    React.createElement("span", { className: gs('text-muted') }, ' ··· '),
                    lottery.number_alphabet[numbers[numbers.length - 1]]),
                React.createElement("span", { className: gs('text-muted') }, t('options_count', { count: numbers.length })))); })),
        React.createElement("div", { dangerouslySetInnerHTML: { __html: lottery.read_me } })) || React.createElement(Loader, null));
};
var Users = function (_a) {
    var t = useTranslation()[0];
    var dataframe = useDataframe(AuthService.users, {
        perPage: 10
    });
    return React.createElement(React.Fragment, null,
        React.createElement("h3", { className: gs('mb-4') }, t('users')),
        React.createElement("table", { className: gs('table-overview', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '30%' } }, t('name')),
                    React.createElement("th", { style: { width: '30%' } }, t('email')),
                    React.createElement("th", { style: { width: '20%' } }, t('role')),
                    React.createElement("th", { style: { width: '20%' } }, t('verified')))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: 4 }),
                dataframe.getData().map(function (user) { return React.createElement("tr", { key: user.id },
                    React.createElement("td", null,
                        React.createElement(FontAwesomeIcon, { icon: "user-circle" }),
                        ' ',
                        React.createElement("strong", null, user.name)),
                    React.createElement("td", null, user.email),
                    React.createElement("td", null,
                        React.createElement("span", { className: gs('badge', 'badge-light') }, t("roles:".concat(user.role)))),
                    React.createElement("td", null,
                        React.createElement("small", null,
                            React.createElement(DateTime, { date: user.email_verified_at })))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })));
};
var History = function (_a) {
    var t = useTranslation(['general', 'auditor'])[0];
    var dataframe = useDataframe(HistoryService.getHistory, {
        perPage: 10
    });
    return React.createElement(React.Fragment, null,
        React.createElement("h3", { className: gs('mb-4') }, t('history')),
        React.createElement("table", { className: gs('table-overview', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '45%' } }, t('event')),
                    React.createElement("th", { style: { width: '40%' } }, t('value')),
                    React.createElement("th", { style: { width: '15%' } }, t('time')))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: 1 }),
                dataframe.getData().map(function (entry) { return React.createElement("tr", { key: entry.id },
                    React.createElement("td", null,
                        React.createElement("strong", null, entry.actor && React.createElement("span", null,
                            React.createElement(FontAwesomeIcon, { icon: "user-circle" }),
                            ' ',
                            entry.actor.actor_identification) || t('lotus')),
                        ' ',
                        t("events:".concat(entry.event)),
                        ' ',
                        entry.model && React.createElement("span", null,
                            React.createElement("strong", null, entry.model.to_string)),
                        entry.model_type && React.createElement(React.Fragment, null,
                            " ",
                            React.createElement("span", { className: gs('badge', 'badge-light') }, t("morph_types:".concat(entry.model_type))))),
                    React.createElement("td", null,
                        entry.attribute && React.createElement(React.Fragment, null,
                            t(entry.attribute),
                            ":",
                            ' '),
                        React.createElement("code", null, entry.attribute !== null && entry.value === null ? '-' : entry.value)),
                    React.createElement("td", null,
                        React.createElement("small", null,
                            React.createElement(DateTime, { date: entry.timestamp })))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })));
};
export default withRouter(Dashboard);
